import { expVal } from '@atlassian/jira-feature-experiments';

export const isWorkItemModernizationGatesEnabled = (): boolean => {
	return (
		expVal('work_item_modernization', 'isEnabled', false) ||
		expVal('work_item_for_quadratic', 'isEnabled', false)
	);
};
